import gql from 'graphql-tag'

export const GET_SCANNED_ATTENDEES = gql`
  query GetScannedAttendees($eventId: ID!) {
    getScannedAttendees(eventId: $eventId) {
      id, status, createdAt,
      attendee {
        id, firstName, lastName
      }
    }
  }
`
